import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

const padding = layout.spacing.xSmall;

export const SortButton = styled.div`
  width: 100%;
  border-bottom: 1px solid ${p => p.theme.lines.primary};
  border-top: 1px solid ${p => p.theme.lines.primary};
  margin-bottom: ${layout.spacing.xSmall};

  .ui-dropdown--header {
    padding: 0;
  }

  .ui-dropdown--toggle-button {
    padding: ${padding};
  }

  .ui-dropdown--selected,
  .ui-dropdown--toggle-button {
    width: 100%;
    text-align: left;
  }
`;
